import { put, call, delay } from 'redux-saga/effects';
import { FlowId, FlowStoppedReason } from '@constants/flows';

import { Result } from './utils';

import { stopFlow, addFlowData, changeFlowStep } from '../actions/flows';

// We can delete it once we start to integrate real flows
export function* doAddFlowData(flowId, data) {
  console.log('Saga: Adding flow data:', flowId, data);
  yield put(addFlowData(flowId, data));
}

export function* exampleFlow(config = {}) {
  console.log('Saga: Starting example flow saga with config:', config);
  const { data } = config;

  if (data) {
    yield call(doAddFlowData, FlowId.EXAMPLE, data);
  }

  console.log('Saga: Changing step to STEP_1');
  yield put(changeFlowStep(FlowId.EXAMPLE, 'STEP_1', 'forward'));
  yield delay(10000);
  console.log('Saga: Changing step to STEP_2');
  yield put(changeFlowStep(FlowId.EXAMPLE, 'STEP_2', 'forward'));
  yield delay(10000);

  console.log('Saga: Changing step to STEP_3');
  yield put(changeFlowStep(FlowId.EXAMPLE, 'STEP_3', 'forward'));
  yield delay(10000);

  return { result: Result.SUCCESS };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function* (config) {
  console.log('Saga: Executing example flow saga with config:', config);
  const { result } = yield call(exampleFlow, {
    ...config,
    flow: FlowId.EXAMPLE,
  });
  if (result === Result.SUCCESS) {
    yield put(stopFlow(FlowId.EXAMPLE, FlowStoppedReason.COMPLETE));
  }
}
